import '../../initSentryClient'; // sentry 초기화를 가장 상단에 넣으라고 한다

import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router';
import HaewaoApp from './HaewaoApp';
import './css/index.css';
import { SsrProvider } from '@client/ssr/SsrProvider';
import * as Sentry from '@sentry/react';

ReactDOM.hydrateRoot(
    document.getElementById('app') as HTMLElement,
    <React.StrictMode>
        <BrowserRouter>
            <SsrProvider
                value={{
                    ssrData: window.__SSR_DATA__ || {},
                }}
            >
                <HelmetProvider>
                    <HaewaoApp />
                </HelmetProvider>
            </SsrProvider>
        </BrowserRouter>
    </React.StrictMode>,
    {
        // Callback called when an error is thrown and not caught by an ErrorBoundary.
        onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
            console.warn('Uncaught error', error, errorInfo.componentStack);
        }),
        // Callback called when React catches an error in an ErrorBoundary.
        onCaughtError: Sentry.reactErrorHandler(),
        // Callback called when React automatically recovers from errors.
        onRecoverableError: Sentry.reactErrorHandler(),
    },
);
